import { Mutation, MutationTree } from "vuex";
import { AlertMutation, AlertState, AlertType } from "../types";

export const mutations: MutationTree<AlertState> &
  Record<AlertMutation, Mutation<AlertState>> = {
  [AlertMutation.SetShow](state, show: boolean) {
    state.show = show;
  },
  [AlertMutation.SetMessage](state, message: string) {
    state.message = message;
  },
  [AlertMutation.SetAlertType](state, alertType?: AlertType) {
    state.alertType = alertType ? alertType : AlertType.Info;
  }
};
